
<section class="col-seleccion">
  <fieldset>
    <div style = "margin-top: 28px;" ></div>
  <div class="tituloInt tituloPago">{{ 'CODIGO_CLIENTE' | translate }}</div>
  <ticketing-validar-cliente-asociado></ticketing-validar-cliente-asociado>
  <label [ngClass]="colorTexto()" *ngIf = "(mensajeError && mensajeError.length > 0) || tipoCliente" class="asociado-label">{{ mostrarTexto() | translate}}</label>
  <div *ngIf="entradasDisponibles" class = "separador" ></div>
  <div *ngIf="entradasDisponibles" class="tituloInt tituloPago">{{ 'ENTRADAS_DISPONIBLES' | translate }}</div>
  <div class="asociadoWrap">
    <div class="entradas" *ngIf="entradasDisponibles">
      <div
        class="Rtable-cell asociado-cell"
        (click)="selectEntrada(entrada)"
        [ngClass]="{
          active: entradaSeleccionada !== entrada,
          select: entradaSeleccionada === entrada
        }"
        *ngFor="let entrada of entradasDisponibles"
      >
        <div class="Rtable-cell--content row">{{ entrada.NombrePantalla }}</div>
        <div class="Rtable-cell--content row">
          ({{ entrada.Maximo }})
        </div>
        <input
          style="visibility: hidden; display: none;"
          id="motivo-{{ entrada.ItemId }}"
          type="number"
          class="qty text"
          step="1"
          min="0"
          name="quantity"
          category="ASOCIADO"
        />
      </div>
    </div>
  </div>
  <div *ngIf="entradasConsumidas" class = "separador" ></div>
   <div *ngIf="entradasConsumidas" class="tituloInt tituloPago">{{ 'ENTRADAS_CONSUMIDAS' | translate }}
   </div>
  <div class="wrap-tabs-seleccion" *ngIf="entradasConsumidas">    
    <div id="tabs-content" *ngIf="entradasConsumidas && entradasConsumidas.length > 0">
      <div style="width: 80%; margin-left: 10%;" id="tabSel-01">
        <div class="Rtable" >
        <div class="Rtable-row Rtable-row--head">
          <div class="Rtable-cell item-cell column-heading centrado">
            {{ 'ENTRADAS' | translate }}
          </div>
          <div class="Rtable-cell item-cell column-heading centrado">
            {{ 'CANTIDAD' | translate }}
          </div>
          <div class="Rtable-cell item-cell column-heading derecha">
            {{ 'FECHA_Y_HORA' | translate }}
          </div>
          <div class="Rtable-cell item-cell column-heading derecha">
            {{ 'ORIGEN' | translate }}
          </div>
        </div>
        <div class="listado">
            <div
              class="Rtable-row"
              [ngClass]="{
                selected: entradaSeleccionada === entrada
              }"
              *ngFor="let entrada of entradasConsumidas" 
            >
              <div class="Rtable-cell item-cell">
                <div class="Rtable-cell--content item-content">
                  {{ entrada.NombrePantalla }}
                </div>
              </div>
              <div class="Rtable-cell item-cell">
                <div class="Rtable-cell--content item-content centrado">
                  {{ entrada.CantidadCompra }}
                </div>
              </div>
              <div class="Rtable-cell item-cell">
                <div class="Rtable-cell--content item-content derecha">
                  {{ entrada.FechaCompra }}
                </div>
              </div>
              <div class="Rtable-cell item-cell">
                <div class="Rtable-cell--content item-content derecha">
                  {{ entrada.OrigenCompra }}
                </div>
              </div>
            </div>     
        </div>
        <!-- <ul class="pagination" *ngIf="pager.pages && pager.pages.length > 1 && entradas.length > 0">
          <li>
            <a (click)="setPage(pager.currentPage - 1)" title="Previo">
              <img
                class="svg"
                src="assets/img/active-arrow.svg"
                alt="icono prev"
              />
            </a>
          </li>
          <li *ngFor="let page of pager.pages">
            <a
              (click)="setPage(page)"
              [ngClass]="{ active: pager.currentPage === page }"
              >{{ page }}</a
            >
          </li>
          <li>
            <a (click)="setPage(pager.currentPage + 1)" title="Próximo">
              <img
                class="svg"
                src="assets/img/active-arrow.svg"
                alt="icono next"
              />
            </a>
          </li>
        </ul> -->
        </div>
      </div>
      
    </div>
    </div>
    <div class = "centro" *ngIf="entradasConsumidas && entradasConsumidas.length == 0">
      <label>{{ 'NO_HAY_ENTRADAS' | translate}}</label>
    </div>
   </fieldset>
</section>
<div id = "cliente-asociado">
  <section class="col-resumen">
    <fieldset>
      <div class="white-box">
        <div class="Rtable">
          <div class="Rtable-row Rtable-row--head">
            <div class="Rtable-row-inner">
              <div class="Rtable-cell item-cell column-heading">{{ 'ENTRADA' | translate }}</div>
              <div class="Rtable-cell cantidad-cell column-heading">{{ 'CANT' | translate }}</div>
              <div class="Rtable-cell delete-cell column-heading"></div>
            </div>
          </div>
          <div class="detailScroll" *ngIf="listaEntradasSeleccionadas">
            <div class="Rtable-row" *ngFor="let entrada of listaEntradasSeleccionadas">
              <div class="Rtable-row-inner">
                <div class="Rtable-cell item-cell">
                  <div class="Rtable-cell--content item-content">{{ entrada.NombrePantalla }}</div>
                </div>
                <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                  <div class="Rtable-cell--content cantidad-content">
                    <div class="quantity">
                      <input
                        type="number"
                        class="qty text"
                        step="1"
                        min="0"
                        name="quantity"
                        value="{{ entrada.cantidad }}"
                        title="Cantidad"
                        size="4"
                        (keydown)="inputDeTeclado($event, entrada)"
                        (focus)="focusValue($event, entrada)"
                        category="ASOCIADO"
                      />
                    </div>
                  </div>
                </div>
                <div class="Rtable-cell delete-cell">
                  <div class="Rtable-cell--content delete-content">
                    <a (click)="eliminarEntrada(entrada)" title="Borrar">
                      <span class="cross"></span>
                      <span class="sr-only">{{ 'CERRAR' | translate }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </fieldset>

    <div class="NumpadWrap">
      <div class="totales">
        <div class="titulos">
          <span>{{ 'CANTIDAD' | translate }}</span>
          <span>{{ 'TOTAL' | translate }}</span>
        </div>
        <div class="numeros" *ngIf="listaEntradasSeleccionadas">
          <span>{{ getCantidadTotal() }}</span>
          <span
            >{{ getPrecioTotal() | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo  : divisaSimboloDerecha : divisaSimbSeparacionMiles}}
            {{ divisaSimbolo }}</span
          >
        </div>
      </div>
      <ticketing-numpad></ticketing-numpad>
      <button
        type="button"
        value="APLICAR DESCUENTOS"
        (click)="avanzar()"
        class="pagar descuentos"
      >
        {{ 'SIGUIENTE' | translate }}
      </button>
    </div>
  </section>
</div>
